export interface IMapSettingsReducerState {}

export const defaultState: IMapSettingsReducerState = {};

export const mapSettings = (
    state: IMapSettingsReducerState = { ...defaultState },
    action
): IMapSettingsReducerState => {
    switch (action.type) {
        default:
            return state;
    }
};
